/**
 * Tiny dev-only logger.
 *
 * Why: code review flagged `console.debug` calls leaking debug info in
 * production builds. We want to KEEP them in dev (they make support
 * easier when reproducing user issues) but gate them behind NODE_ENV so
 * they don't ship in the production bundle's runtime behaviour.
 *
 * `console.warn` and `console.error` are intentionally NOT wrapped — they
 * surface real problems that need to be visible to anyone debugging a
 * production deployment.
 */
const isDev = process.env.NODE_ENV === "development";

export const logger = {
  debug: (...args) => { if (isDev) console.debug(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};
